import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const COMMVARIETY = {
  getCommList: {
    success: "COMM_GET_ALL_SUCCESS",
    error: "COMM_GET_ALL_ERROR"
  },
  getCommVarietyList: {
    success: "COMMVARIETY_GET_ALL_SUCCESS",
    error: "COMMVARIETY_GET_ALL_ERROR"
  },
  create: {
    success: "COMMVARIETY_CREATE_SUCCESS",
    error: "COMMVARIETY_CREATE_ERROR"
  },
  edit: {
    success: "COMMVARIETY_EDIT_SUCCESS",
    error: "COMMVARIETY_EDIT_ERROR"
  },
  update: {
    success: "COMMVARIETY_UPDATE_SUCCESS",
    error: "COMMVARIETY_UPDATE_ERROR"
  },
  delete: {
    success: "COMMVARIETY_DELETE_SUCCESS",
    error: "COMMVARIETY_DELETE_ERROR"
  }
};

export const commListAction = () => {
  let url = `/ntrac/commodity/commodityList`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.id = item.name;
        });
        dispatch({ type: COMMVARIETY.getCommList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const commVariertyLstAction = (harvestYear=harvestYearDetail().name) => {
  return (dispatch,getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/commodityVariety/farmId/${
    userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
  }?harvestYear=${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format('ll');
          item.name = item.commodityResponseDTO.name;
          item.lbsPerBushel = item.commodityResponseDTO.lbsPerBushel;
          item.updatedBy=item.variety=="General"?"NTRAC":item.updatedBy;
        });
        dispatch({ type: COMMVARIETY.getCommVarietyList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createCommVarietyAction = commVarietyInfo => {
  let url = `/ntrac/commodityVariety`;
  return dispatch => {
    globalApiHandler(url, "post", commVarietyInfo)
      .then(response => {
        dispatch({ type: COMMVARIETY.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editCommVarietyAction = data => {
  return dispatch => {
    dispatch({ type: COMMVARIETY.edit.success, data });
  };
};

export const updateCommVarietyAction = commVarietyInfo => {
  let url = `/ntrac/commodityVariety/${commVarietyInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", commVarietyInfo)
      .then(response => {
        dispatch({ type: COMMVARIETY.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteCommVarietyAction = id => {
  let url = `/ntrac/commodityVariety/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: COMMVARIETY.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/commvarieties/action.js